import { Button } from 'antd';
import styled from 'styled-components';

export const OperatorBtn = styled(Button)<any>`
  background-color: ${alo7Theme.auxColor};
  color: #fff;
  &:hover,
  &:focus {
    color: ${alo7Theme.auxColor};
    background-color: #fff;
    border-color: ${alo7Theme.auxColor};
  }
`;

export const TranBtn = styled(Button)<any>`
  background-color: #fff;
  color: #333;
  border-color: #fff;
  &:active,
  &:hover,
  &:focus {
    color: #333;
    background-color: #fff;
    border-color: #fff;
  }
  &[alo7-click-animating-without-extra-node]:after {
    border: 0 none;
    opacity: 0;
    animation: none 0 ease 0 1 normal;
  }
`;

export const TranBtnSpliter = styled.div`
  width: 1px;
  border-left: 1px solid #9e9e9e59;
  height: 20px;
  margin: 0 0.5em;
`;

export const PageHeader = styled.div`
  display: flex;
  font-size: 20px;
  color: #3f3f3f;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  flex: 0 0 auto;
`;

export const PageLayout = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background: rgb(248, 248, 249);
`;
export const CommonHeader = styled.div`
  background: #fff;
  padding: 13px;
  margin: 5px 0 10px 10px;
  display: flex;
  font-size: 20px;
  color: #3f3f3f;
  justify-content: space-between;
  align-items: center;
  flex: 0 0 auto;
`;
export const CommonResult = styled.div`
  margin-top: 10px;
  margin-left: 10px;
  padding: 13px;
  background: #fff;
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  & .ant-table-tbody > .ant-table-row > td:first-child > span {
    display: inline-block;
    vertical-align: middle;
  }
`;
export const SearchArea = styled.div`
  background: #fff;
  padding: 13px;
  margin: 0 0 10px 10px;
  display: flex;
  font-size: 20px;
  color: #3f3f3f;
  justify-content: space-between;
  align-items: center;
  flex: 0 0 auto;
`;
export const DelDiv = styled.div`
  background: transparent;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    background: rgba(255, 121, 68, 0.05);
  }
`;

export const PrimaryBtn = styled(Button)<any>`
  background: #1890ff !important;
  color: #fff !important;
  border: none !important;

  i {
    color: #fff !important;
  }

  &:hover {
    background: #51c7ff !important;
  }

  &:focus {
    background: #2776e3 !important;
    border: none !important;
  }

  &[disabled] {
    opacity: 0.5;
  }
`;

export const DefaultBtn = styled(Button)`
  background: #fff;
  border: 1px solid #fff !important;

  &:hover {
    border: 1px solid #1890ff !important;
  }

  &:focus {
    border: 1px solid #1890ff !important;
  }

  &[disabled] {
    opacity: 0.5;
  }
`;

export const CancelBtn = styled(Button)`
  border: 1px solid transparent;
  background-color: hsla(209, 2%, 95%, 1);
  &:hover {
    border: 1px solid transparent;
    background-color: hsla(209, 2%, 95%, 1);
    color: rgba(0, 0, 0, 0.85);
  }
`;

export const StyledHoverIcon = styled.div<{
  type?: string;
  visibleShow?: any;
  hidden?: boolean;
  visibility?: string;
}>`
  background-color: none;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: ${props => (props.hidden && 'none') || 'flex'};
  justify-content: space-around;
  align-items: center;
  &:hover {
    background-color: ${props =>
      props.type === 'publish' ? 'rgba(82, 196, 26, 0.05)' : '#eafaf7'};
    i:hover {
      color: ${props => (props.type === 'publish' ? '#52c41a' : '')};
    }
  }
  & i {
    margin-right: 0 !important; // antd 在menu组件中会把i加上margin-right
  }
`;

export const StyledHoverIconEdit = styled(StyledHoverIcon)`
  font-size: 15px;
  color: rgb(155, 155, 155);
  margin-left: 10px;
  &:hover {
    background-color: #eafaf7;
    color: #ff8157;
  }
`;

export const StyledHoverIconDelete = styled(StyledHoverIcon)`
  font-size: 16px;
  color: rgb(155, 155, 155);
  &:hover {
    background-color: #eafaf7;
    color: #ff8157;
  }
`;

export const SortButtonGroup = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #fff;
  margin: 0 0 0 10px;
  // padding: 10px 13px;
  border-radius: 4px;

  & .filterSelect .ant-select-selection,
  .filterSelect .ant-select-selection:focus,
  .filterSelect .ant-select-selection:active {
    border: none;
    box-shadow: none;
  }
`;
